(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeLevelCare', TypeLevelCare);

    TypeLevelCare.$inject = ['$resource'];

    function TypeLevelCare ($resource) {
        var resourceUrl =  'api/type-level-cares/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'forms': {url: 'api/type-level-cares/forms/:facId/:lcId', method: 'GET', isArray: true},
            'update': { method:'PUT' },
            'filter': {url: 'api/type-level-cares/filter', method: 'GET', isArray: true},
            'findAllByFacility': {url: 'api/type-level-cares/by-facility/:id', method: 'GET', isArray: true}
        });
    }
})();
